import React from 'react';
import PropTypes from 'prop-types';
import { Item, Header, Grid } from 'semantic-ui-react';
import ClaimList from './ClaimList';
import ReportClaimModal from './ReportClaimModal';
import EmailAddress from '../../EmailAddress';
import moment from 'moment';
import PhoneNumber from '../../PhoneNumber';

const Claim = ({ claim }) => {
	return (
		<Item className='claim'>
			<Item.Content>
				<Item.Header>Claim: {claim.number.startsWith('P') ? 'Pending' : claim.number}</Item.Header>
				<Item.Meta>{claim.type}</Item.Meta>
				<Item.Description>
					<Grid columns='equal' stackable>
						<Grid.Column>
							<div className='field'>
								<Header as='h2' className='bold'>
									Date:
								</Header>
								<Header as='h2'>{moment(claim.lossDate).format('MM/DD/YYYY')}</Header>
							</div>
							<div className='field'>
								<Header as='h2' className='bold'>
									Status:
								</Header>
								<Header as='h2'>{claim.status}</Header>
							</div>
						</Grid.Column>
						<Grid.Column>
							<div className='field'>
								<Header as='h2' className='bold'>
									Policy Type:
								</Header>
								<Header as='h2'>{claim.policy.type}</Header>
							</div>
							<div className='field'>
								<Header as='h2' className='bold'>
									Policy Number:
								</Header>
								<Header as='h2'>{claim.policy.policyNumber}</Header>
							</div>
							<div className='field'>
								<Header as='h2' className='bold'>
									Policyholder:
								</Header>
								<Header as='h2'>{claim.policy.policyHolder.displayName}</Header>
							</div>
						</Grid.Column>
						{claim.representative && (
							<Grid.Column>
								<div className='field'>
									<Header as='h2' className='bold'>
										Claim Rep:
									</Header>
									<Header as='h2'>{claim.representative.name}</Header>
								</div>
								{claim.representative.email && (
									<div className='field'>
										<Header as='h2' className='bold'>
											Claim Rep Email:
										</Header>
										<Header as='h2'>
											<EmailAddress emailAddress={claim.representative.email} subject={`CLAIM NUMBER ${claim.number}, Policy ${claim.policy.policyNumber}, Insured ${claim.policy.policyHolder.displayName}`} text={claim.representative.email} />
										</Header>
									</div>
								)}
								{claim.representative.phone && (
									<div className='field'>
										<Header as='h2' className='bold'>
											Claim Rep Phone:
										</Header>
										<PhoneNumber phoneNumber={claim.representative.phone}></PhoneNumber>
									</div>
								)}
							</Grid.Column>
						)}
					</Grid>
				</Item.Description>
			</Item.Content>
		</Item>
	);
};

Claim.List = ClaimList;
Claim.ModalReportClaim = ReportClaimModal;

Claim.propTypes = {
	claim: PropTypes.object.isRequired,
};

export default Claim;
